module.exports = __webpack_public_path__ + "TRUONGpel.ef49caae.png";